import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaChevronDown } from "react-icons/fa";
import Logo from "../assets/images/rabta logo.png";
import * as Popover from '@radix-ui/react-popover';
import { IoInformationCircleOutline } from 'react-icons/io5';
import { AiOutlineInfoCircle } from 'react-icons/ai';

export default function RetailerCashbacks() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [entries, setEntries] = useState();
  const [showAdjustmentPopup, setShowAdjustmentPopup] = useState(false);
  const [selectedAdjustmentItem, setSelectedAdjustmentItem] = useState(null);

  const [isLoading, setIsLoading] = useState(true);

  const hasAnyAdjustments = entries?.some(item =>
    (item?.week1Entries || 0) + (item?.week2Entries || 0) + (item?.top250Week2PendingAmount || 0) > 0
  );

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const fetchCashbackHistory = () => {
    const stored = localStorage.getItem("retailer");
    if (!stored) {
      navigate("/retailers/login");
      return;
    }

    const user = JSON.parse(stored);
    setIsLoading(true);

    fetch(
      `${process.env.REACT_APP_API_URL}retailers/cashgram/history/${user._id}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setEntries(data.data || []);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchCashbackHistory();
  }, [navigate]);


  const handleClaimCashback = async (item) => {
    if (item.cashgramLink) {
      window.open(item.cashgramLink, '_blank', 'noopener,noreferrer');
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}retailers/createCashgram/${item._id}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      const result = await response.json();

      if (result.status === 'success' && result.data?.cashgramLink) {
        fetchCashbackHistory();
        window.open(result.data.cashgramLink, '_blank', 'noopener,noreferrer');
      } else {
        // alert(t("retailer.cashback.error") || "Failed to generate cashback link");
      }
    } catch (error) {
      console.error('Error creating cashgram:', error);
    }
  };


  return (
    <div className="main-bg">
      <div className="congrats-page">
        <div className="backBtn-wrapper">
          <a className="backBtn" onClick={() => navigate("/retailers/dashboard")}>
            <FaArrowLeft style={{ marginRight: "6px" }} />
            <p>{t("retailer.cashback.back")}</p>
          </a>
        </div>
        <div>
          <img src={Logo} alt="logo" className="logo-main" />

          {isLoading ? (
            <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>
              <p>{t("retailer.loading") || "Loading..."}</p>
            </div>
          ) : entries?.length === 0 ? (
            <div style={{ textAlign: "center", padding: "60px 20px" }}>
              <h2 style={{ marginBottom: "20px", color: "#333" }}>
                {t("retailer.cashback.noDataYet") || "No Cashback Data Yet"}
              </h2>
              <p style={{ color: "#666", fontSize: "16px" }}>
                {t("retailer.cashback.noDataMessage")}
              </p>
            </div>
          ) : (
            <div >
              <div style={{ marginBottom: "20px" }}>
                <h2>{t("retailer.cashback.history").toUpperCase()}</h2>
                <p>
                  {t("retailer.cashback.description")}
                </p>
              </div>
              <div className="entries-table">

                <div className="table-content">
                  <table>
                    <thead>
                      <tr>
                        <th>{t("retailer.date")}</th>
                        {/* <th>{t("retailer.time")}</th> */}
                        <th>{t("retailer.entries")}</th>
                        <th>{t("retailer.perEntryAmount")}</th>
                        <th>{t("retailer.top250Winner")}</th>
                        <th>{t("retailer.top250Amount")}</th>
                        <th>{t("retailer.totalAmount")}</th>
                        {/* Conditionally render Adjustment Amount column */}
                        {hasAnyAdjustments && (
                          <th>
                            <Popover.Root>
                              <Popover.Trigger asChild>
                                <a
                                  style={{
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    cursor: 'pointer',
                                    font: 'inherit',
                                    gap: '4px'
                                  }}
                                >
                                  <span>Adjustment</span>  <br />
                                  <span> Amount</span>
                                </a>
                              </Popover.Trigger>
                              <Popover.Portal>
                                <Popover.Content
                                  className="popover-content"
                                  sideOffset={5}
                                  side="bottom"
                                  align="center"
                                  onPointerDownOutside={() => { }}
                                  onInteractOutside={() => { }}
                                  onEscapeKeyDown={() => { }}
                                >
                                  <div className="adjustment-info">
                                    <p className="main-text">
                                      We've identified some entries from previous weeks that were missed earlier.
                                      These have now been included and will be added to your Week 4 payout.
                                    </p>
                                    <br />
                                    <p className="section-title">Pending Adjustments:</p>
                                    <br />

                                    {(() => {
                                      const entryWithAdjustments = entries?.find(item =>
                                        (item?.week1Entries || 0) + (item?.week2Entries || 0) + (item?.top250Week2PendingAmount || 0) > 0
                                      );
                                      const week1Entries = entryWithAdjustments?.week1Entries || 0;
                                      const week2Entries = entryWithAdjustments?.week2Entries || 0;
                                      const top250Week2PendingAmount = entryWithAdjustments?.top250Week2PendingAmount || 0;
                                      const week1Amount = week1Entries * 5;
                                      const week2Amount = week2Entries * 5;
                                      const totalAmount = week1Amount + week2Amount + top250Week2PendingAmount;

                                      return (
                                        <>
                                          {week1Entries > 0 && (
                                            <div className="adjustment-item">
                                              <p className="week-title">Week 1 Adjustment:</p>
                                              <ul>
                                                <li>Entries: {week1Entries}</li>
                                                <li>Amount: ₹{week1Amount}</li>
                                              </ul>
                                            </div>
                                          )}
                                          {week1Entries > 0 && week2Entries > 0 && <br />}
                                          {week2Entries > 0 && (
                                            <div className="adjustment-item">
                                              <p className="week-title">Week 2 Adjustment:</p>
                                              <ul>
                                                <li>Entries: {week2Entries}</li>
                                                <li>Amount: ₹{week2Amount}</li>
                                              </ul>
                                            </div>
                                          )}
                                          {(week1Entries > 0 || week2Entries > 0) && top250Week2PendingAmount > 0 && <br />}
                                          {top250Week2PendingAmount > 0 && (
                                            <div className="adjustment-item">
                                              <p className="week-title">Top 250 Week 2 Pending:</p>
                                              <ul>
                                                <li>Amount: ₹{top250Week2PendingAmount}</li>
                                              </ul>
                                            </div>
                                          )}
                                          <p className="total">Total Adjustment: ₹{totalAmount}</p>
                                        </>
                                      );
                                    })()}
                                  </div>
                                  <Popover.Arrow className="popover-arrow" style={{ fill: '#fff' }} />
                                </Popover.Content>
                              </Popover.Portal>
                            </Popover.Root>
                          </th>
                        )}


                        <th>{t("retailer.rewardStatus")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {entries?.map((item, i) => {
                        // Calculate adjustment amount for this row
                        const week1Entries = item?.week1Entries || 0;
                        const week2Entries = item?.week2Entries || 0;
                        const top250Week2PendingAmount = item?.top250Week2PendingAmount || 0;

                        const adjustmentAmount =
                          (week1Entries + week2Entries) * 5 + top250Week2PendingAmount;

                        const hasAdjustments = adjustmentAmount > 0;

                        return (
                          <tr key={item._id || i}>
                            <td>
                              {item.createdAt
                                ? new Date(item.createdAt).toLocaleDateString('en-IN', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric'
                                })
                                : '-'}
                            </td>
                            {/* <td> 
                              {item.createdAt
                                ? new Date(item.createdAt).toLocaleTimeString('en-IN', {
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                })
                                : '-'}
                            </td>   */}
                            <td>
                              {(item?.entries || 0) +
                                (item?.week1Entries || 0) +
                                (item?.week2Entries || 0) + 
                                (item?.prevEntries || 0)}
                            </td>
                            <td>₹{item.rs5Amount || 0}</td>
                            <td>
                              {item.top250 ? (
                                <span style={{ fontWeight: "bold" }}>
                                  {t("retailer.yes") || "Yes"}
                                </span>
                            ) : (
                               <span>{"-"}</span>
                              )}
                            </td>
                            <td>{item.top250Amount ? '₹' + item.top250Amount : '-'}</td>
                            <td style={{ fontWeight: "bold" }}>₹{item.totalAmount || 0}</td>
                            {/* Conditionally render adjustment amount cell */}
                            {hasAnyAdjustments && (
                              <td>
                                {hasAdjustments ? (
                                  <>
                                    ₹{adjustmentAmount}
                                    <AiOutlineInfoCircle
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setShowAdjustmentPopup(true);
                                        setSelectedAdjustmentItem(item);
                                      }}
                                      style={{
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                        marginLeft: '4px'
                                      }}
                                    />
                                  </>
                                ) : (
                                  '-'
                                )}
                              </td>
                          )}
                          <td>
                              {item.cashgramStatus === "CASHGRAM_REDEEMED" ? (
                                <span className="redeemed-text">{t("retailer.claimed")}</span>
                              ) : item.cashgramStatus === "CASHGRAM_EXPIRED" ? (
                                <span className="redeemed-text">{t("retailer.expired")}</span>
                              ) : item.cashgramStatus === "CASHGRAM_TRANSFER_REVERSAL" ? (
                                <span className="redeemed-text">{t("retailer.reversed")}</span>
                              ) : (
                                (item.cashgramLink) ? (
                                  <>
                                    {item.cashgramStatus == 'CASHGRAM_PENDING' ? (
                                      <a
                                        className="claim-cashback"
                                        href={item.cashgramLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Claim
                                      </a>
                                    ) : <p>{item.cashgramStatus}</p>}
                                  </>
                                ) : (
                                  <button
                                    className="claim-cashback"
                                    onClick={() => handleClaimCashback(item)}
                                  >
                                    Claim
                                  </button>
                                )
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          )}

          {/* Adjustment Popup Modal */}
          {showAdjustmentPopup && (() => {
            const item = selectedAdjustmentItem || entries?.[entries.length - 1];
            const week1Entries = item?.week1Entries || 0;
            const week2Entries = item?.week2Entries || 0;
            const top250Week2PendingAmount = item?.top250Week2PendingAmount || 0;
            const week1Amount = week1Entries * 5;
            const week2Amount = week2Entries * 5;
            const totalAdjustmentAmount = week1Amount + week2Amount + top250Week2PendingAmount;

            return (
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'rgba(0, 0, 0, 0.5)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 1000
                }}
                onClick={() => {
                  setShowAdjustmentPopup(false);
                  setSelectedAdjustmentItem(null);
                }}
              >
                <div
                  style={{
                    background: 'white',
                    borderRadius: '12px',
                    padding: '24px',
                    maxWidth: '400px',
                    width: '90%',
                    color: '#333',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '16px'
                  }}>
                    <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>
                      Pending Entries for Cashback
                    </h3>
                    <a
                      onClick={() => {
                        setShowAdjustmentPopup(false);
                        setSelectedAdjustmentItem(null);
                      }}
                      style={{
                        background: 'none',
                        border: 'none',
                        fontSize: '24px',
                        cursor: 'pointer',
                        color: '#666'
                      }}
                    >
                      ×
                    </a>
                  </div>

                  <p style={{ marginBottom: '16px', lineHeight: '1.5', fontSize: '14px' }}>
                    We've identified some entries from previous weeks that were missed earlier.
                    These have now been included and will be added to your Week 4 and Week 5 payout.
                  </p>

                  <div style={{
                    background: '#f5f5f5',
                    borderRadius: '8px',
                    padding: '16px',
                    marginBottom: '12px'
                  }}>
                    <p style={{ fontWeight: 'bold', marginBottom: '12px', fontSize: '14px' }}>
                      Pending Adjustments:
                    </p>

                    {week1Entries > 0 && (
                      <div style={{ marginBottom: '12px' }}>
                        <p style={{ fontWeight: '600', marginBottom: '6px', fontSize: '13px' }}>
                          Week 1 Adjustment
                        </p>
                        <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '13px' }}>
                          <li>Entries: {week1Entries}</li>
                          <li>Amount: ₹{week1Amount}</li>
                        </ul>
                      </div>
                    )}

                    {week2Entries > 0 && (
                      <div style={{ marginBottom: '12px' }}>
                        <p style={{ fontWeight: '600', marginBottom: '6px', fontSize: '13px' }}>
                          Week 2 Adjustment
                        </p>
                        <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '13px' }}>
                          <li>Entries: {week2Entries}</li>
                          <li>Amount: ₹{week2Amount}</li>
                        </ul>
                      </div>
                    )}

                    {top250Week2PendingAmount > 0 && (
                      <div style={{ marginBottom: '12px' }}>
                        <p style={{ fontWeight: '600', marginBottom: '6px', fontSize: '13px' }}>
                          Top 250 Week 2 Pending
                        </p>
                        <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '13px' }}>
                          <li>Amount: ₹{top250Week2PendingAmount}</li>
                        </ul>
                      </div>
                    )}

                    <div style={{
                      borderTop: '2px solid #ddd',
                      paddingTop: '12px',
                      marginTop: '12px',
                      fontWeight: 'bold',
                      fontSize: '14px'
                    }}>
                      Total Adjustment: ₹{totalAdjustmentAmount}
                    </div>
                  </div>
                </div>
              </div>
            );
          })()}

          {/* Language selector at bottom */}
          <div className="language-selector-bottom">
            <select
              value={i18n.language}
              onChange={(e) => changeLanguage(e.target.value)}
              className="language-dropdown-bottom"
            >
              <option value="en">English</option>
              <option value="ur">Urdu</option>
            </select>
            <div className="arrow-wrapper-bottom">
              <FaChevronDown className="dropdown-icon" fontSize={'14px'} />
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}
